import { render, staticRenderFns } from "./LandingLoanPage.vue?vue&type=template&id=8451d16a&scoped=true"
import script from "./LandingLoanPage.vue?vue&type=script&lang=ts"
export * from "./LandingLoanPage.vue?vue&type=script&lang=ts"
import style0 from "./LandingLoanPage.vue?vue&type=style&index=0&id=8451d16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8451d16a",
  null
  
)

export default component.exports